import styled from "styled-components";

export const ContractPanel = styled.div`
    background-color: ${props => props?.theme?.palette?.contractElementPanel};
    color: ${props => props?.theme?.palette?.black};
    width: 99%;
    padding: 1em 1em 1em 1em;
    border-radius: 10px;
    margin-top: 1em;
    max-height: 400px;
    overflow: auto;
    & hr
    {
        margin: 40px 0;
        border: solid 1px #e9eff2;
    }
`;